module.exports = __webpack_public_path__ + "media/ב.249ee8ea.mp3";